<script lang="ts" context="module">
  export type DynamicPage =
    | FaqPage
    | GamePage
    | LegalPage
    | Page
    | ProductDetailPage
    | ShopPage
    | ShopPageGroup
    | QuizPage;

  export const GLOBAL_RELATIONS = [
    'shop-the-look-section.looks',
    'products-showcase.products',
    'four-products.products',
    'synced-block.synced_block',
    'synced-product-detail.synced_block',
    'product-highlight.product',
    'game.game',
    'recommendations.products',
    'style-block.products',
    'products-with-cta.products',
    'products-grid.products',
    'shop-the-look-cards.looks',
    'shop-the-look-card.look',
    'products-row.products',
    'single-product.product',
    'collections-cross-sell.collections',
    'product-recommendations.products',
    'styled-by-you-section.styles_list',
    'styled-by-you.products',
    'shop-page.sub_collections'
  ];
</script>

<script lang="ts">
  import ShopPageGroupComponent from './shop-page-group/shop-page-group.svelte';
  import ShopPageComponent from './shop-page/shop-page.svelte';
  import LegalPageComponent from './legal-page/legal-page.svelte';
  import PageComponent from './page/page.svelte';
  import ProductDetailPageComponent from './product-detail-page/product-detail-page.svelte';
  import FaqPageComponent from './faq-page/faq-page.svelte';
  import GamePageComponent from './game-page/game-page.svelte';
  import QuizPageComponent from './quiz-page/quiz-page.svelte';

  import { isShopPageGroup, type ShopPageGroup } from './shop-page-group/content';
  import { isShopPage, type ShopPage } from './shop-page/content';
  import { isProductDetailPage, type ProductDetailPage } from './product-detail-page/content';
  import { isLegalPage, type LegalPage } from './legal-page/content';
  import { isPage, type Page } from './page/content';
  import { isFaqPage, type FaqPage } from './faq-page/content';
  import { isGamePage, type GamePage } from './game-page/content';
  import { isQuizPage, type QuizPage } from './quiz-page/content';

  export let data: DynamicPage;
</script>

{#if isShopPage(data)}
  <ShopPageComponent {data} />
{:else if isShopPageGroup(data)}
  <ShopPageGroupComponent {data} />
{:else if isProductDetailPage(data)}
  <ProductDetailPageComponent {data} />
{:else if isLegalPage(data)}
  <LegalPageComponent {data} />
{:else if isFaqPage(data)}
  <FaqPageComponent {data} />
{:else if isGamePage(data)}
  <GamePageComponent {data} />
{:else if isQuizPage(data)}
  <QuizPageComponent {data} />
{:else if isPage(data)}
  <PageComponent {data} />
{/if}
